// src/lib/authRedirect.ts
//
// Constructs the redirect URL for Supabase OAuth callbacks.
// Current live student auth: Google OAuth + one-time university email pairing.
// See docs/CANONICAL_AUTH_MODEL.md for the full auth architecture.
//
// NOTE (historical): Azure/Entra was previously used for student auth.
// That provider is no longer active. Microsoft references in Supabase config
// are legacy and do not affect the current Google OAuth flow.
//
export function getAuthRedirect(options?: { role?: string; params?: Record<string, string> }) {
  // Determine base origin
  let base = '';
  if (typeof window !== 'undefined') {
    base = window.location.origin;
  } else {
    base = process.env.NEXT_PUBLIC_APP_URL || "https://durmah.ai";
  }

  // Normalize and force HTTPS for known production/dev domains
  base = base.replace(/\/$/, '');
  if (base.includes('netlify.app') || base.includes('durmah.ai')) {
    base = base.replace('http://', 'https://');
  }

  // CTW-DURMAH-UNIVERSAL-SIGNUP-FOUNDING-WINDOW-01: the OAuth callback is
  // allowlisted on the canonical www host. Starting the flow from the apex
  // host made Supabase fall back to the bare Site URL, so the student landed
  // on the homepage with a session but never reached /auth/callback or
  // university verification. Always hand Google the canonical www origin.
  if (base === 'https://durmah.ai') {
    base = 'https://www.durmah.ai';
  }

  const url = new URL(`${base}/auth/callback`);

  if (options?.role) {
    url.searchParams.set('role', options.role);
  }

  if (options?.params) {
    Object.entries(options.params).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }

  const finalUrl = url.toString();
  console.log('[authRedirect] Constructed redirect URL:', finalUrl);
  return finalUrl;
}
